








































































































































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase'
import {GetTenantInfo} from '../../../api/realTime'
import myTable from '../../../components/table/my-table.vue'

@Component({
    components: {myTable}
})
export default class extends AbpBase {
    @Prop({type:Object,default:{}}) data:any;
    @Watch('data')
    wD(){
        if(this.data){
            this.list = this.data.data
            this.list1 = this.list.concat();
            this.list2 = this.list.concat();
            this.list3 = this.list.concat();
            this.list4 = this.list.concat();
        }
    }
    list = []
    list1 = []
    list2 = []
    list3 = []
    list4 = []
    getsort(sortName,list,sortData){
        switch(sortName){
            case '按名称升序':
                list.sort((item1, item2)=>{
                    return item2.tenantName.localeCompare(item1.tenantName, 'zh-CN');
                })
                break;
            case '按名称降序':
                list.sort((item1, item2)=>{
                    return item1.tenantName.localeCompare(item2.tenantName, 'zh-CN');
                })
                break;
            case '按达标率升序':
                list.sort((item1, item2)=>{
                    return Number(item2[sortData])-Number(item1[sortData])
                })
                break;
            case '按达标率降序':
                list.sort((item1, item2)=>{
                    return Number(item1[sortData])-Number(item2[sortData])
                })
                break;
        }
    }
    created(){
        if(this.data){
            this.list = this.data.data
            this.list1 = this.list.concat();
            this.list2 = this.list.concat();
            this.list3 = this.list.concat();
            this.list4 = this.list.concat();
        }
    }
    dateChange(){
        this.$emit('dateChange',this.formatDate(this.date).split('-')[0],this.formatDate(this.date).split('-')[1])
    }
    date = new Date()
    label = '月达标率'
    reachRate1 = '按名称升序'
    reachRate2 = '按名称升序'
    reachRate3 = '按名称升序'
    reachRate4 = '按名称升序'
    //条件列
    conditions = [
        {text:'按名称升序'},
        {text:'按名称降序'},
        {text:'按达标率升序'},
        {text:'按达标率降序'},
    ]
    columns = [
        {
            title: '名称',
            key: 'tenantName'
        },
        {
            title: '达标率',
            key: 'standardsRates',
            render:(h:any,p:any)=>{
                return h('span',p.row.standardsRates+'%')
            },
        },
        {
            title: '不达标率',
            key: 'notStandardsRates',
            render:(h:any,p:any)=>{
                return h('span',p.row.notStandardsRates+'%')
            },
        },
        {
            title: '超标率',
            key: 'exceededRates',
            render:(h:any,p:any)=>{
                return h('span',p.row.exceededRates+'%')
            },
        },
    ]

    
}
